module.exports = __webpack_public_path__ + "img/i-marvel.224d673e.png";